import { getType } from 'typesafe-actions';

import { NetworkRequestState } from '@bolteu/redux-session';

import { getMenuAsyncAction, MenuActions, updateMenuAsyncAction } from './actions';
import { MenuScheme } from './scheme';

export interface MenuState {
  data: MenuScheme;
  fetchingState: NetworkRequestState;
  updateRequestState: NetworkRequestState;
}

const initialState: MenuState = {
  data: {
    entities: {
      category: {},
      dish: {},
      optionGroup: {},
      option: {},
    },
    result: {
      categories: [],
      dishes: [],
      optionGroups: [],
      options: [],
    },
  },
  updateRequestState: NetworkRequestState.unset,
  fetchingState: NetworkRequestState.unset,
};

export const menuReducer = (state: MenuState = initialState, action: MenuActions): MenuState => {
  switch (action.type) {
    case getType(getMenuAsyncAction.request): {
      return {
        ...state,
        fetchingState: NetworkRequestState.waiting,
      };
    }
    case getType(getMenuAsyncAction.success): {
      return {
        ...state,
        data: action.payload,
        fetchingState: NetworkRequestState.success,
      };
    }
    case getType(getMenuAsyncAction.failure): {
      return {
        ...state,
        fetchingState: NetworkRequestState.failure,
      };
    }

    case getType(updateMenuAsyncAction.request): {
      return {
        ...state,
        updateRequestState: NetworkRequestState.waiting,
      };
    }
    case getType(updateMenuAsyncAction.success): {
      return {
        ...state,
        updateRequestState: NetworkRequestState.success,
      };
    }
    case getType(updateMenuAsyncAction.failure): {
      return {
        ...state,
        updateRequestState: NetworkRequestState.failure,
      };
    }
    default: {
      return state;
    }
  }
};
